const state: () => any = () => ({
    mainMenu: null,
    cityList: null,
});

export default state;
